import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100vh',
    overflow: 'auto',
    fontFamily: 'Roboto',
    '@media all and (max-width: 900px)': {
      height: '100vh',
      marginTop: 80,
      marginBottom: 100
    }
  },
  boxtitle: {
    width: '90%',
    display: 'flex',
    color: '#4B4952',
    marginLeft: '5%',
    marginTop: '1.5rem'
  },
  title: {
    fontSize: '2em',
    fontWeight: 500,
    letterSpacing: '0.04rem',
    '@media all and (max-width: 600px)': {
      fontSize: '1.5em'
    }
  },
  boxSubTitle: {
    width: '90%',

    color: '#2C3532',
    marginLeft: '5%',
    marginTop: '0.5rem',
    paddingLeft: '0.2rem',
    '@media all and (max-width: 600px)': {
      fontSize: '0.8em'
    }
  },
  boxTable: {
    width: '95%',
    marginTop: '1rem',
    marginLeft: '5%'
  },
  boxButtonAdd: {
    marginTop: '1.2rem',
    marginLeft: '5.5%',
    display: 'flex'
  },
  boxDetails: {
    width: '80%',
    marginLeft: '5%',
    marginTop: '2%',
    paddingBottom: 5,
    paddingTop: 5,
    background: '#f9f9f9',
    boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
    borderRadius: 10
  },
  buttonVerifyStateMEApp: {
    backgroundColor: '#f9f9f9',
    boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
    borderRadius: 5,
    marginTop: '2%',
    marginLeft: '5%',
    border: '1px solid #dbdbdb',
    padding: 10,
    maxWidth: '50%',
    borderLeft: '4px solid #00A88F',
    cursor: 'pointer',
    color: '#008471',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.5)'
    }
  },
  subtitle: {
    fontSize: '1rem',
    marginLeft: 8,
    fontWeight: 'bold'
  }
}))

export default useStyles
